import PropTypes from 'prop-types';
import styles from './FJOrientationChoose.module.less';
import ArrowIcon from '../../../assets/svg/button-right-2.svg?react';
import { useState } from 'react';
// import CheckIcon from '../../../assets/svg/choose.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import FJDropdownNew from '../../components/FJDropDown/FJDropdownNew';
import FJUtil from '../../../util/FJUtil';
import FJHelpIcon from '../../../assets/svg/help.svg?react';

const FJOrientationChoose = props => {
    const { value, onChange, list, className, buttonClassName } = props;
    const [showSideModel, setShowSideModel] = useState(false);
    // 添加响应式位置状态
    const curObj = list.find(item => item.value === value);

    const handleOnMouseDown = e => {
        showSideModel && e.stopPropagation();
    };

    const _onChange = value => {
        onChange(value);
        setShowSideModel(false);
    };
    const renderTrigger = ({ ref, onClick }) => {
        return (
            <div
                className={classNames(styles.btu, buttonClassName)}
                onClick={onClick}
                onMouseDown={handleOnMouseDown}
                data-active={showSideModel}
                ref={ref}
            >
                {FJLocalStore._(curObj?.outName || curObj?.name)}
                <ArrowIcon className={styles.arrow_icon} />
            </div>
        );
    };
    const _renderHelpTrigger = config => {
        return (
            <span className={styles.labeled_switch_icon} onClick={config.onClick} ref={config.ref}>
                <FJHelpIcon />
            </span>
        );
    };

    const _renderHelpOverlay = config => {
        return (
            <div className={styles.labeled_switch_desc} ref={config.ref}>
                {FJLocalStore._('generate-the-orientation-of-the-characters-in-the-video')}
            </div>
        );
    };
    const renderOverlay = ({ ref }) => {
        return (
            <div className={styles.overlay} ref={ref}>
                <div className={styles.overlay_title}>{FJLocalStore._('character-orientation')}</div>

                <div className={styles.list_box}>
                    {list?.map(item => {
                        return (
                            <div
                                className={classNames(styles.item, item.name === curObj?.name && styles.item_active)}
                                key={item.name}
                                onClick={() => _onChange(item.value)}
                            >
                                <div
                                    className={styles.item_name}
                                    dangerouslySetInnerHTML={{ __html: FJLocalStore._(item.name) }}
                                ></div>
                                <div className={styles.item_desc}>{FJLocalStore._(item.desc)}</div>
                                {/* {item.value === curObj?.value && <CheckIcon className={styles.check_icon} />} */}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };
    return (
        <div className={classNames(styles.box, className)}>
            <div className={styles.title}>
                {FJLocalStore._('character-orientation')}
                <FJDropdownNew
                    renderTrigger={_renderHelpTrigger}
                    useAnchorBody
                    placement='rightTop'
                    trigger='click'
                    renderOverlay={_renderHelpOverlay}
                    offsetLeft={8}
                    offsetTop={-11}
                    isTopLayer
                />
            </div>
            <FJDropdownNew
                renderTrigger={renderTrigger}
                renderOverlay={renderOverlay}
                offsetLeft={20}
                offsetTop={-21}
                trigger='click'
                placement='rightTop'
                zIndex={FJUtil.isLandingPage() ? 4 : 999}
                useAnchorBody
                canTriggerActive
                onHide={() => setShowSideModel(false)}
                onShow={() => setShowSideModel(true)}
            />
        </div>
    );
};

FJOrientationChoose.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    list: PropTypes.array,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
};
export default FJOrientationChoose;
